<template>
    
</template>

<script>
    import PreviewButtonElement from "./PreviewButtonElement";
    import SocialShareButtonElement from "../../components/pagesbuilder/elements/SocialShareButtonElement";

    export default {
        name: "PreviewSocialShareButtonElement",
        mixins: [
            PreviewButtonElement,
            SocialShareButtonElement
        ],
        methods: {
            addListeners () {
                const socialNetwork = this.getSocialNetwork();
                const title = document.title;
                const source = document.URL;
                this.myNode.addEventListener('click', () => {
                    this.shareTo(socialNetwork, title, source);
                });
            },
            shareTo (socialNetwork, title, source) {
                const windowParams = 'scrollbars=0, resizable=1, menubar=0, left=100, top=100, width=550, height=440, toolbar=0, status=0';
                let url, windowName;

                switch (socialNetwork) {
                    case 'twitter':
                        url = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(title) + "&url=" + encodeURIComponent(source);
                        break;
                    case 'facebook':
                        url = "http://www.facebook.com/sharer.php?u=" + encodeURIComponent(source)+ "&p=" + encodeURIComponent(title);
                        break;
                    case 'linkedin':
                        url = "https://www.linkedin.com/shareArticle?mini=true&url=" + encodeURIComponent(source) + "&title=" + encodeURIComponent(title);
                        break;
                    case 'pinterest':
                        windowName = 'PinterestWindow';
                        url = "https://pinterest.com/pin/create/button/?url=" + encodeURIComponent(source) + "&description=" + encodeURIComponent(title); // needs &media={image.url}
                        break;
                }
                if (url) {
                    window.open(url, windowName, windowParams);
                }
            }
        }
    }
</script>
